import {useMutation, UseMutationOptions} from '@tanstack/react-query';
import {AudienceChangeDto} from '@tinct/core-api-models';
import {ApiError, tinctApi} from '../../api';

export interface PreviewAudienceChangeParams {
  id: string;
  audienceId: string;
}

export const previewAudienceChange = async (
  params: PreviewAudienceChangeParams,
): Promise<AudienceChangeDto> => {
  return await tinctApi.campaigns.previewAudienceChange(params.id, params.audienceId);
};

export const usePreviewAudienceChange = (
  options?: Omit<
    UseMutationOptions<AudienceChangeDto, ApiError, PreviewAudienceChangeParams>,
    'mutationFn'
  >,
) =>
  useMutation({
    mutationFn: previewAudienceChange,
    ...options,
  });
